var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerInox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21566_15931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6752 31.5469L16.9998 31.824L17.3245 31.5469C21.1193 28.3074 23.9884 25.2712 25.9119 22.4356C27.8342 19.6015 28.8332 16.9364 28.8332 14.45C28.8332 7.10354 23.2104 2.33331 16.9998 2.33331C10.7892 2.33331 5.1665 7.10354 5.1665 14.45C5.1665 16.9364 6.16545 19.6015 8.08782 22.4356C10.0113 25.2712 12.8803 28.3074 16.6752 31.5469Z",
    fill: "#DCE2EF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3638 19.8978V9.46594H13.5229V10.625H14.682V9.46594H19.3183V10.625H20.4774V9.46594H21.6365V19.8978H20.4774V18.7387H19.3183V19.8978H14.682V18.7387H13.5229V19.8978H12.3638ZM13.5229 17.5796H14.682V16.4205H13.5229V17.5796ZM13.5229 15.2614H14.682V14.1023H13.5229V15.2614ZM13.5229 12.9432H14.682V11.7841H13.5229V12.9432ZM19.3183 17.5796H20.4774V16.4205H19.3183V17.5796ZM19.3183 15.2614H20.4774V14.1023H19.3183V15.2614ZM19.3183 12.9432H20.4774V11.7841H19.3183V12.9432ZM15.841 18.7387H18.1592V10.625H15.841V18.7387Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21566_15931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerInox);
export default __webpack_public_path__ + "static/media/marker-inox.9d68dce167847e9a64a6476241a55a7c.svg";
export { ForwardRef as ReactComponent };